import angular from 'angular';

class TabsWidgetController {
  static $inject = ['$element'];

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-tabs-widget');
  }
}

export const TabsWidgetComponentModule = angular
  .module('acme.common.component.tabs.tabsWidget', [])
  .component('acmeTabsWidget', {
    templateUrl: 'common/components/tabs/tabs-widget.component.tpl.html',
    controller: TabsWidgetController,
    transclude: true,
    bindings: {},
  }).name;
